const p: string[] = []; export default p;
